module.exports = __webpack_public_path__ + "img/ap2.beace21e.png";